import {SubClass} from "./subClass";

export class SubInformation{

  id: string;
  nameShort: string;
  nameLong: string;
  subClass: SubClass;
  received: boolean;
  requested: boolean;


}
